import { Subject, takeUntil } from 'rxjs';

import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { ControlStatusJP } from '../../../../../shared/consts';
import { DynamoDbService } from '../../services/dynamodb.service';
import { ErrorBarService } from '../../services/error-bar.service';
import { FilterService } from '../../services/filter.service';
import { WebSocketService } from '../../services/websocket.service';
import { ControlDetail } from '../../shared/app-consts';

const columns = [
  'ControlID', 'ControlDescription', 'Status', "ApplicationCount","StatusButton" // 'ControlUnitBaseScore',
];


@Component({
  selector: 'app-control-list',
  templateUrl: './control-list.component.html',
  styleUrl: './control-list.component.sass',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  #cdr = inject(ChangeDetectorRef);
  #ddb = inject(DynamoDbService);
  #filter = inject(FilterService);
  #errorBar = inject(ErrorBarService);
  #webSocket = inject(WebSocketService);
  #ActivatedRoute = inject(ActivatedRoute);

  private destroy$ = new Subject<void>();
  dataSource!: MatTableDataSource<ControlDetail>;
  filteredDataSource!: MatTableDataSource<ControlDetail>;
  AccountID: string = '';
  searchText = '';
  uniqueServices: string[] = [];
  selectedServices: { [service: string]: boolean } = {};
  selectedStatuses: { [status: string]: boolean } = {
    '申請済み': false,
    '未完了': false,
    '完了': false
  };
  get displayedColumns(): string[] {
    return columns;
  }
  get ControlStatusJP(): typeof ControlStatusJP {
    return ControlStatusJP;
  }

  onSearchTextChanged(searchText: string): void {
    this.searchText = searchText;
    this.applyFilter();
  }
  onSelectedServicesChanged(selectedServices: { [service: string]: boolean }): void {
    this.selectedServices = selectedServices;
    this.applyFilter();
  }
  onSelectedStatusesChanged(selectedStatuses: { [status: string]: boolean }): void {
    this.selectedStatuses = selectedStatuses;
    this.applyFilter();
  }

  constructor() {
    this.#webSocket.controlUpdate.pipe(
      takeUntil(this.destroy$)
    ).subscribe(({ accountId, controlId, status }) => {
      this.#ddb.fetchControlDetailByAccountID(accountId).pipe(
        takeUntil(this.destroy$)
      ).subscribe(details => {
        this.#defDataSource(details);
        this.#errorBar.showStatusNotification(controlId, status);
      });
    });
  }

  ngOnInit(): void {
    this.AccountID = this.#ActivatedRoute.snapshot.params['team'];
    this.#webSocket.currentAccountID = this.AccountID;
    this.#ddb.fetchControlDetailByAccountID(this.AccountID).pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.#defDataSource.bind(this));
  }

  ngOnDestroy(): void {
    this.#webSocket.currentAccountID = '';
    this.destroy$.next();
    this.destroy$.complete();
    this.#errorBar.clear();
  }

  #defDataSource(res: ControlDetail[]): void {
    this.dataSource = new MatTableDataSource<ControlDetail>(res);
    this.#initializeUniqueServicesAndStatuses();
    this.applyFilter();
  }

  #initializeUniqueServicesAndStatuses(): void {
    const allServices = this.dataSource.data.map(item =>
      this.#getServiceName(item.ControlID));
    this.uniqueServices = Array.from(new Set(allServices));
    for (const service of this.uniqueServices) {
      this.selectedServices[service] = false;
    }
  }
  #getServiceName(controlId: string): string {
    return controlId.split('.')[0];
  }

  applyFilter(): void {
    let filteredResults = this.dataSource.data;

    if (this.searchText) {
      filteredResults = this.#filter.filterBySearchTextB(filteredResults, this.searchText);
    }
    filteredResults = this.#filter.filterServicesAndStatusesB(filteredResults, this.selectedServices, this.selectedStatuses);
    this.filteredDataSource = new MatTableDataSource<ControlDetail>(filteredResults);

    this.#applyPaginator();
    this.#cdr.markForCheck();
  }

  #applyPaginator(): void {
    if (this.paginator && this.filteredDataSource) {
      this.filteredDataSource.paginator = this.paginator;
      this.#cdr.markForCheck();
    }
  }

  submitForReview(AccountId: string, ControlId: string, Status: number): void {
    this.#errorBar.showMessage(`${ControlId} 申請処理中...`);
    this.#ddb.updateControlStatus(AccountId, ControlId, Status).subscribe({
      error: (err) => this.#errorBar.handleError(err)
    });
  }

  submiterror(): void {
    this.#errorBar.handleError(new Error('Error'));
  }
}